import Panel from "@/components/ui/Panel";
import type { SponsorsBlock } from "@/interfaces/event_page";

// The Figma's sponsors.zip band. A sponsor is a name; the logo and the link are
// both optional, so this has to look deliberate with neither - a local boba
// shop that donated the drinks usually has no logo to send.
export default function SponsorPanel({ block }: { block: SponsorsBlock }) {
  return (
    <Panel title="sponsors.zip" tone="alt">
      <div className="flex flex-col gap-6">
        <h2 className="font-display text-heading text-ink-muted text-center font-bold">
          {block.heading ?? "thank you to our sponsors!"}
        </h2>

        <ul className="flex flex-wrap items-center justify-center gap-6">
          {block.items.map((sponsor) => {
            const body = (
              <>
                {sponsor.logo_url && (
                  <img
                    src={sponsor.logo_url}
                    alt=""
                    loading="lazy"
                    className="h-16 w-auto max-w-40 object-contain"
                  />
                )}
                <span className="font-display text-body text-ink font-bold">
                  {sponsor.name}
                </span>
              </>
            );

            return (
              <li key={sponsor.name}>
                {sponsor.url ? (
                  <a
                    href={sponsor.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-link flex flex-col items-center gap-2 hover:underline"
                  >
                    {body}
                  </a>
                ) : (
                  <div className="flex flex-col items-center gap-2">{body}</div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </Panel>
  );
}
